import { useEffect, useState } from 'react';

import { logger } from '../../../../common/logger';
import { Get } from '../../../../common/utilities/api-wrapper';

const useGetNews = newsURL => {
  const [news, setNews] = useState([]);
  const [areNewsLoaded, setAreNewsLoaded] = useState(false);

  const getNews = async () => {
    try {
      const { results } = await Get(newsURL);
      setNews(results);
      setAreNewsLoaded(true);
    } catch (error) {
      setAreNewsLoaded(true);
      logger.error('Error getting news API from utility services', error);
    }
  };

  useEffect(() => {
    getNews();
  }, []);

  return {
    news,
    areNewsLoaded
  };
};

export default useGetNews;
